import { render, staticRenderFns } from "./SdkPage.vue?vue&type=template&id=730c6397&scoped=true&"
import script from "./SdkPage.vue?vue&type=script&lang=js&"
export * from "./SdkPage.vue?vue&type=script&lang=js&"
import style0 from "./SdkPage.vue?vue&type=style&index=0&id=730c6397&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730c6397",
  null
  
)

export default component.exports